import React from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

const ImageDirection = ({ image, imageMobile, alt, className }) => {
  if (!image) {
    return <></>
  }

  const images = withArtDirection(
    getImage(image),
    imageMobile
      ? [
          {
            media: '(max-width: 992px)',
            image: getImage(imageMobile)
          }
        ]
      : []
  )

  return <GatsbyImage image={images} alt={alt} className={className} />
}

export default ImageDirection
